import { Grid, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import CounterInput from "./CounterInput";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import SlideUpTransition from "../fundamentals/SlideUpTransition";
import { copyJsonObject } from "../../util/commonUtils";
import { isAwardedBid } from "../../util/bid/bidCommon.js";
import { getDayOfTheWeek, getFormattedMonthAndDate } from "../../util/bid/freedayBidUtils";
import { isEqual } from "lodash";

const useStyles = makeStyles((theme) => ({
  counteStyle: {
    display: "flex",
    justifyContent: "space-around",
    fontSize: "28px",
    fontWeight: "bold",
  },
  dialogStyle: {
    width: "600px",
    margin: "auto",
    height: "425px",
  },
}));

const StandardAllotmentDialog = (props) => {
  const classes = useStyles();
  const [amCount, setAmCount] = useState(null);
  const [pmCount, setPmCount] = useState(null);
  const [eitherCount, setEitherCount] = useState(null);
  const [amOrPmCount, setAmOrPmCount] = useState(null);
  useEffect(() => {
    const selectedDayState = props?.standardDayState?.find((dayState) => dayState?.date === props?.date);
    setAmCount(selectedDayState?.amCount);
    setPmCount(selectedDayState?.pmCount);
    setAmOrPmCount(selectedDayState?.amOrPmCount);
    setEitherCount(selectedDayState?.eitherCount);
    // eslint-disable-next-line
  }, [props.standardDayState, props.date]);

  const handleCancelButtonClick = () => {
    const existingDayState = props.standardDayState.find((dayState) => dayState.date === props.date);
    const newDayState = {
      ...existingDayState,
      date: props.date,
      amCount: amCount,
      pmCount: pmCount,
      eitherCount: eitherCount,
      amOrPmCount: amOrPmCount,
    };
    if (!isEqual(existingDayState, newDayState)) {
      const copiedStandardDayState = copyJsonObject(props.standardDayState);
      const updatedStandardDayState = copiedStandardDayState.map((dayState) =>
        dayState.date === props.date ? newDayState : dayState
      );
      props.setStandardDayState(updatedStandardDayState);
    }
    props.setIsAllotmentDialogOpen(false);
  };

  return (
    <Dialog
      className={classes.dialogStyle}
      fullWidth
      open={props.isAllotmentDialogOpen}
      TransitionComponent={SlideUpTransition}
      keepMounted
      onClose={handleCancelButtonClick}
      data-testid="standard-allotment-dialog"
    >
      <DialogContent sx={{ padding: "10px" }}>
        <Grid container justifyContent={"flex-end"}>
          <CloseIcon onClick={handleCancelButtonClick} sx={{ cursor: "pointer", padding: "2px" }} />
        </Grid>
        <Box
          sx={{
            border: "solid 0.5px",
            borderColor: "secondary.swaGray4",
            marginTop: "10px",
          }}
        >
          {props.date ? (
            <div>
              <Grid
                container
                spacing={1}
                justifyContent={"flex-end"}
                sx={{ paddingRight: "5px", fontSize: "24px", fontWeight: "bold" }}
              >
                <Grid item>{getDayOfTheWeek(props.date)}</Grid>
                <Grid item sx={{ color: "primary.swaBlue" }}>
                  {getFormattedMonthAndDate(props.date)}
                </Grid>
              </Grid>
              {(amOrPmCount > 0 || amCount > 0) &&
                (amOrPmCount > 0 ? (
                  <Grid
                    container
                    sx={{
                      textAlign: "center",
                      justifyContent: "space-around",
                      fontSize: "28px",
                      fontWeight: "bold",
                      padding: "35px",
                    }}
                  >
                    <CounterInput
                      title="AM OR PM"
                      count={amOrPmCount}
                      setCount={setAmOrPmCount}
                      minValue={1}
                      maxValue={1}
                      disabled={isAwardedBid(props.bid.status)}
                    />
                  </Grid>
                ) : (
                  <Grid
                    sx={{
                      textAlign: "center",
                      padding: "35px",
                    }}
                  >
                    <Grid sx={{ fontSize: "36px", fontWeight: "bold", marginBottom: "30px" }}>
                      {amCount + eitherCount + pmCount}
                    </Grid>
                    <Grid className={classes.counteStyle}>
                      <CounterInput
                        title="AM"
                        count={amCount}
                        setCount={setAmCount}
                        minValue={1}
                        disabled={isAwardedBid(props.bid.status)}
                      />

                      <CounterInput
                        title="EITHER"
                        count={eitherCount}
                        setCount={setEitherCount}
                        minValue={0}
                        maxValue={1}
                        disabled={isAwardedBid(props.bid.status)}
                      />

                      <CounterInput
                        title="PM"
                        count={pmCount}
                        setCount={setPmCount}
                        minValue={1}
                        disabled={isAwardedBid(props.bid.status)}
                      />
                    </Grid>
                  </Grid>
                ))}
            </div>
          ) : (
            <></>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

StandardAllotmentDialog.propTypes = {
  date: PropTypes.string.isRequired,
  standardDayState: PropTypes.array.isRequired,
  isAllotmentDialogOpen: PropTypes.bool.isRequired,
  setStandardDayState: PropTypes.func.isRequired,
  bid: PropTypes.object.isRequired,
};

export default StandardAllotmentDialog;
